import { TFormalOffer } from './formalOffers.types';

export const getOfferInterestRate = (offer: TFormalOffer): number | null =>
    offer.interest_rates?.[0]?.rate ?? null;
